import RequestPasswordResetForm from "../../ui/request-password-reset-form";

const RequestPasswordResetPage = () => {
  return <RequestPasswordResetForm />;
};

export default RequestPasswordResetPage;